import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { FeatureListFiltersComponent } from './feature-list-filters.component';
import { FeatureFilterSearchComponent } from './feature-filter-search/feature-filter-search.component';

@NgModule({
  declarations: [FeatureListFiltersComponent, FeatureFilterSearchComponent],
  exports: [FeatureListFiltersComponent, FeatureFilterSearchComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InfiniteScrollModule]
})
export class FeatureListFiltersModule {}
